module.exports = __webpack_public_path__ + "static/media/note.3194806e.webp";